import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'chassis-button-plugin',
    templateUrl: './button-plugin.component.html',
    styleUrls: ['./button-plugin.component.scss']
})
export class ButtonPluginComponent implements OnInit {

    @Input() public class;
    @Input() public form;

    constructor() {

    }

    ngOnInit() {

        this.class = this.class ? this.class : ['btn-primary'];

    }

    public submit() {

        this.form.submit();

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/plugins/button-plugin/button-plugin.component.ts